import { urlMainAPI, showError } from "@/global";
import axios from 'axios';

const MediatorIndicatorEditor = {
    indicatorsList: [],
    screenPositionsList: [],
    mediatorLoading: true,
    selectorEnable: false,
    collectorsFound: [],
    automTypes: [],
    analyticsTypes: [],
    isCreatingRoot: false,
    uniqueHosts:[],
    uniqueServers:[],
    mappingList: [],
    allowedTags:[],
    harvestPlanList: [],
    advancedFunctionsAllowed: ['<', '>', '<=', '>=', '<>', 'AND', 'OR', '0', '-9999', 'true', 'false', 'if', 'else', 'then', ',', ':', 'avg', 'wavg', 'cavg', 'cwavg', 'sum', 'csum', 'sub', 'csub', 'cmul', 'cdiv', 'ccount', 'min', 'max'],
    operationsAllowed: [
        {
            group: 'ops',
            groupName: 'Operadores',
            ops: [
                { label: '(', isFunc: false, tooltip: `Abrir Parêntese:\nExemplo:\n(valor_01 ...` },
                { label: ')', isFunc: false, tooltip: `Fechar Parêntese:\nExemplo:\n... valor_02)` },
                { label: '+', isFunc: false, tooltip: `Soma:\nExemplo:\nvalor_01 + valor_02` },
                { label: '-', isFunc: false, tooltip: `Subtração:\nExemplo:\nvalor_01 - valor_02` },
                { label: '*', isFunc: false, tooltip: `Multiplicação:\nExemplo:\nvalor_01 * valor_02` },
                { label: '/', isFunc: false, tooltip: `Divisão:\nExemplo:\nvalor_01 / valor_02` },
                { label: '^', isFunc: false, tooltip: `Exponenciação:\nExemplo:\nvalor_01 ^ 2` },
                { label: 'SQRT', isFunc: true, tooltip: `Raiz Quadrada (√):\nExemplo:\nSQRT( valor_01 )` },
            ]
        },
        {
            group: 'condits',
            groupName: 'Condicionais/Auxiliares',
            ops: [
                { label: 'if', isFunc: true, tooltip: `Estrutura Condicional de Afirmação (SE):\nExemplo:\nif ( valor_01 > 0 ) then ...` },
                { label: 'else', isFunc: true, tooltip: `Estrutura Condicional de Negação (SENÃO):\nExemplo:\nif ( valor_01 > 0 ) then ( valor_01 ) else ( 0 )` },
                { label: 'then', isFunc: true, tooltip: `Estrutura de Execução das Condicionais (ENTÃO):\nExemplo:\nif ( valor_01 > 0 ) then ( valor_01 )` },
                { label: 'true', isFunc: false, tooltip: `Soma:\nExemplo:\nvalor_01 + valor_02` },
                { label: 'false', isFunc: false, tooltip: `false:\nExemplo:\nvalor_01 + valor_02` },
                { label: '0', isFunc: false, tooltip: `Constante de Zero:\nUtilizada em expressões para verificar se o valor é zero.\nExemplo:\nif ( valor_01 <> 0 ) then ...` },
                { label: '-9999', isFunc: false, tooltip: `Constante de Erro:\nUtilizada em expressões para verificar se o valor não foi encontrado.\nExemplo:\nif ( valor_01 <> -9999 ) then ...` },
                { label: ',', isFunc: false, tooltip: `Vírgula:\nUtilizada na construção de expressões.\nExemplo:\navg ( valor_01 , valor_02 )` },
                { label: "'", isFunc: false, tooltip: `Aspas Simples:\nUtilizada na construção de expressões com condicionais.\nExemplo:\ncavg ('<> -9999', valor_01 , valor_02 )` },
                { label: ":", isFunc: false, tooltip: `Dois Pontos:\nUtilizada na construção de expressões com pesos.\nExemplo:\nwavg (valor_01 : peso_01 , valor_02 : peso_02 )` },
            ]
        },
        {
            group: 'ops',
            groupName: 'Lógicas',
            ops: [
                { label: '=', isFunc: false, tooltip: `Condicional de Igualdade:\nExemplo:\nif ( valor_01 = valor_02 ) then ...` },
                { label: '<>', isFunc: false, tooltip: `Condicional de Diferença:\nExemplo:\nif ( valor_01 <> valor_02 ) then ...` },
                { label: '<', isFunc: false, tooltip: `Condicional de Menor:\nExemplo:\nif ( valor_01 < valor_02 ) then ...` },
                { label: '>', isFunc: false, tooltip: `Condicional de Maior:\nExemplo:\nif ( valor_01 > valor_02 ) then ...` },
                { label: '<=', isFunc: false, tooltip: `Condicional de Menor ou Igual:\nExemplo:\nif ( valor_01 <= valor_02 ) then ...` },
                { label: '>=', isFunc: false, tooltip: `Condicional de Maior ou Igual:\nExemplo:\nif ( valor_01 >= valor_02 ) then ...` },
                { label: 'AND', isFunc: false, tooltip: `Operador Lógico (E):\nExemplo:\nif ( valor_01 > 0 AND valor_02 > 0 ) then ...` },
                { label: 'OR', isFunc: false, tooltip: `Operador Lógico (OU):\nExemplo:\nif ( valor_01 > 0 OR valor_02 > 0 ) then ...` },
            ]
        },
        {
            group: 'funcs',
            groupName: 'Funções',
            ops: [
                { label: 'avg', isFunc: true, fullName: 'Média Aritmética', hasWeight: false, hasCondit: false, tooltip: `Média Aritmética\nCalcula o valor médio entre N números.\n( v1 + v2 + ... + vn ) / n\nExemplo:\navg ( valor_01, valor_02 )\nOu: ( valor_01 + valor_02 ) / 2` },
                { label: 'wavg', isFunc: true, fullName: 'Média Ponderada', hasWeight: true, hasCondit: false, tooltip: `Média Ponderada\nCalcula a média entre N números, utilizando pesos para cada item.\n( v1 * p1 + v2 * p2 + ... + vn * pn ) / n\nExemplo:\nwavg ( valor_01 : peso_01, valor_02 : peso_02 )\nOu: ( valor_01 * peso_01 + valor_02 * peso_02 ) / 2` },
                { label: 'cavg', isFunc: true, fullName: 'Média Aritmética Condicional', hasWeight: false, hasCondit: true, tooltip: `Média Aritmética Condicional\nCalcula o valor médio entre N números caso a condicional seja atendida.\n( condição, v1 + v2 + ... + vn ) / n\nExemplo:\ncavg ( ' <> 0 ', valor_01, valor_02 )\nOu: Se o resultado for diferente de 0 faça ( valor_01 + valor_02 ) / 2\nSenão retorne 0` },
                { label: 'cwavg', isFunc: true, fullName: 'Média Ponderada Condicional', hasWeight: true, hasCondit: true, tooltip: `Média Ponderada Condicional\nCalcula a média entre N números, utilizando pesos para cada item, caso a condicional seja atendida.\n( condição, v1 * p1 + v2 * p2 + ... + vn * pn ) / n\nExemplo:\ncwavg ( ' <> 0 ', valor_01 : peso_01, valor_02 : peso_02 )\nOu: Se o resultado for diferente de 0 faça ( valor_01 * peso_01 + valor_02 * peso_02 ) / 2\nSenão retorne 0` },
                { label: 'sum', isFunc: true, fullName: 'Soma', hasWeight: false, hasCondit: false, tooltip: `Soma\nCalcula a soma entre N números.\n( v1 + v2 + ... + vn )\nExemplo:\nsum ( valor_01, valor_02 )\nOu: ( valor_01 + valor_02 )` },
                { label: 'csum', isFunc: true, fullName: 'Soma Condicional', hasWeight: false, hasCondit: true, tooltip: `Soma Condicional\nCalcula a soma entre N números caso a condicional seja atendida.\n( condição, v1 + v2 + ... + vn )\nExemplo:\ncsum ( ' <> 0 ', valor_01, valor_02 )\nOu: Se o resultado for diferente de 0 faça ( valor_01 + valor_02 )\nSenão retorne 0` },
                { label: 'sub', isFunc: true, fullName: 'Subtração', hasWeight: false, hasCondit: false, tooltip: `Subtração\nCalcula a subtração entre N números.\n( v1 - v2 - ... - vn )\nExemplo:\nsub ( valor_01, valor_02 )\nOu: ( valor_01 - valor_02 )` },
                { label: 'csub', isFunc: true, fullName: 'Subtração Condicional', hasWeight: false, hasCondit: true, tooltip: `Subtração Condicional\nCalcula a subtração entre N números caso a condicional seja atendida.\n( condição, v1 - v2 - ... - vn )\nExemplo:\ncsub ( ' <> 0 ', valor_01, valor_02 )\nOu: Se o resultado for diferente de 0 faça ( valor_01 - valor_02 )\nSenão retorne 0` },
                { label: 'cmul', isFunc: true, fullName: 'Multiplicação Condicional', hasWeight: false, hasCondit: true, tooltip: `Multiplicação Condicional\nCalcula a multiplicação entre N números caso a condicional seja atendida.\n( condição, v1 * v2 * ... * vn )\nExemplo:\ncmul ( ' <> 0 ', valor_01, valor_02 )\nOu: Se o resultado for diferente de 0 faça ( valor_01 * valor_02 )\nSenão retorne 0` },
                { label: 'cdiv', isFunc: true, fullName: 'Divisão Condicional', hasWeight: false, hasCondit: true, tooltip: `Divisão Condicional\nCalcula a divisão entre N números caso a condicional seja atendida.\n( condição, v1 / v2 / ... / vn )\nExemplo:\ncdiv ( ' <> 0 ', valor_01, valor_02 )\nOu: Se o resultado for diferente de 0 faça ( valor_01 / valor_02 )\nSenão retorne 0` },
                { label: 'ccount', isFunc: true, fullName: 'Contagem Condicional', hasWeight: false, hasCondit: true, tooltip: `Contagem Condicional\nFaz a contagem de N itens caso a condicional seja atendida.\n( condição, v1 , v2 , ... , vn )\nExemplo:\nccount ( ' <> 0 ', valor_01, valor_02 )\nOu: Se o resultado for diferente de 0 retorne 2\nSenão retorne 0` },
                { label: 'min', isFunc: true, fullName: 'Valor Mínimo', hasWeight: false, hasCondit: false, tooltip: `Valor Mínimo\nObtem o menor valor dentre os N números informados.\nExemplo:\nmin ( valor_01, valor_02 )` },
                { label: 'max', isFunc: true, fullName: 'Valor Máximo', hasWeight: false, hasCondit: false, tooltip: `Valor Máximo\nObtem o maior valor dentre os N números informados.\nExemplo:\nmax ( valor_01, valor_02 )` },
            ]
        },
    ],

    generalConfig: {},
    collected: {},
    calculated: {},

    async init() {
        await this.getIndicatorsList();
        await this.getScreenPositionList();
    },

    async getIndicatorsList() {
        this.indicatorsList = [];

        await axios
            .get(`${urlMainAPI}/getIndicatorEditorTree`)
            .then((res) => {
                if (res.status == 200 && res.data != null) {
                    res.data.map(ind => {
                        if (ind.indicatorRule && ind.indicatorRule != 'root' && ind.indicatorRule != 'rootnode' && !this.indicatorsList.includes(ind)) {
                            let unitParenteses = ind.indicatorName.match(/\(([^()]+)\)/g);
                            let formatedUnit = '';

                            if (unitParenteses != undefined && unitParenteses != null && unitParenteses.length > 0) {
                                formatedUnit = unitParenteses[unitParenteses.length - 1].replace("(", "").replace(")", "")
                            }
                            
                            this.indicatorsList.push({
                                ...ind,
                                indicatorName: ind.indicatorName,
                                unit: formatedUnit,
                            });
                        }
                    })

                    this.indicatorsList.sort((indA, indB) => {
                        if (indA.indicatorName < indB.indicatorName) {
                            return -1;
                        }
                        if (indA.indicatorName > indB.indicatorName) {
                            return 1;
                        }
                        return 0;
                    });
                }
            })
            .catch(err => {
                this.indicatorsList = [];
                showError('Falha ao buscar indicadores.')
                console.error(err)
            });

            return this.indicatorsList;
    },

    async getScreenPositionList() {
        await axios
            .get(`${urlMainAPI}/getIndicatorEditorTreeCardPosition`)
            .then((res) => {
                if (res.status == 200 && res.data != null) {
                    this.screenPositionsList = res.data;
                }
            }).catch((err) => {
                showError('Falha ao carregar telas de monitoramento.')
                console.error(err)
            })
    },

    async getCollectorBases() {
        await axios.get(`${urlMainAPI}/getSysntaxesForm`)
            .then((res) => {
                let bases = Object.keys(res.data.syntaxesCollection).filter(item => !item.toLowerCase().includes('cana'));
                let basesValues = Object.values(res.data.syntaxesCollection);
                this.collectorsFound = bases.map(item => { return { name: item } })

                let analyticsTemp = this.analyticsTypes.length > 0 ? this.analyticsTypes.map(item => item.name.toLowerCase()) : [];

                for (let item of basesValues) {
                    if (item.length > 0 && ["sap", "pims", "gatec"].includes(item[item.length - 1].toLowerCase()) && !analyticsTemp.includes(item[item.length - 1].toLowerCase())) {
                        analyticsTemp.push(item[item.length - 1].toLowerCase())
                        this.analyticsTypes.push({ name: item[item.length - 1] })
                    }
                }

                this.automTypes = res.data.listAutomUsed.map(item => { return { name: item } })

                this.uniqueHosts = res.data.uniqueHosts.map(item => { return { name: item } });
                this.uniqueServers = res.data.uniqueServers.map(item => { return { name: item } });

                this.allowedTags = res.data.allowedTags.map(item => {
                    let splited = item.split('  ');
                    return { tagname: splited[0], coltagname: splited[1], host: splited[2] ? splited[2] : '', serverName: splited[3] ? splited[3] : '' }
                });
            })
            .catch((err) => { console.error(err) })
    },

    checkOPCTags(tagname, opctagname){
        let res = this.allowedTags.filter(item => item.tagname == tagname && item.coltagname.trim() != opctagname.trim())

        if(res.length > 0) return false

        return true
    },

    async generateMapObj() {
        await axios.get(`${urlMainAPI}/getInfosXML`).then(res => {
            let mapObj = res.data;
            let mapKeys = Object.keys(mapObj);

            for (let map of mapKeys) {
                if (map.includes("|name") || map.includes("|nome")) continue;
                let valFormated = mapObj[map].replaceAll(',', '.');

                this.mappingList.push({ map: map, value: isNaN(Number(valFormated)) ? valFormated : Number(valFormated).toFixed(2) })
            }
        }).catch(err => console.error(err))
    },

    /**
     * Avalia equações no mesmo formato aceito pelo MathEngine C# do backend.
     * Suporta: +, -, *, /, ^ (exp), SQRT, avg, sum, sub, min, max, wavg,
     *          if/then/else, AND, OR, =, <>, <, >, <=, >=,
     *          csum, csub, cavg, cmul, cdiv, ccount, cwavg.
     * Variáveis são resolvidas a partir de harvestList (array de { planTag, value }).
     * Retorna número arredondado a 4 casas ou '-' em caso de erro/sem resultado.
     */
    evaluatePlanEquation(equation, harvestList) {
        if (!equation || !equation.trim()) return '-';
        let expr = equation.trim();

        // 1. Verifica se alguma variável da equação está ausente na lista do mês atual
        const planTagSet = new Set((harvestList || []).map(item => `ind_plan_${item.planTag}`));
        const usedTokens = expr.match(/\bind_plan_\w+\b/g) || [];
        if (usedTokens.some(t => !planTagSet.has(t))) return 'Variável não encontrada';

        // 2. Substitui variáveis ind_plan_TAG pelos valores numéricos
        (harvestList || []).forEach(item => {
            const token = `ind_plan_${item.planTag}`;
            const val = parseFloat(item.value);
            expr = expr.split(token).join(isNaN(val) ? '0' : String(val));
        });

        // 2. if ( cond ) then ( a ) else ( b ) → (cond ? a : b)
        // Loop para tratar casos aninhados de dentro para fora
        let prev;
        do {
            prev = expr;
            expr = expr.replace(
                /\bif\b\s*\(([^()]*(?:\([^()]*\)[^()]*)*)\)\s*\bthen\b\s*\(([^()]*(?:\([^()]*\)[^()]*)*)\)\s*\belse\b\s*\(([^()]*(?:\([^()]*\)[^()]*)*)\)/gi,
                '(($1) ? ($2) : ($3))'
            );
        } while (expr !== prev);

        // 3. Transformações de operadores
        expr = expr.replace(/<>/g, '!==');                         // <> → !==
        expr = expr.replace(/(?<![<>!=])=(?!=)/g, '===');          // = → === (não afeta <=,>=,==,!==)
        expr = expr.replace(/\bAND\b/gi, '&&');
        expr = expr.replace(/\bOR\b/gi,  '||');
        expr = expr.replace(/\s*\^\s*/g, ' ** ');                  // ^ → **
        expr = expr.replace(/\bSQRT\s*\(/gi, 'Math.sqrt(');

        // 4. wavg/cwavg: o separador : entre valor e peso vira ,
        //    wavg(v1:w1, v2:w2) → _wavg(v1,w1,v2,w2)
        expr = expr.replace(/\bcwavg\s*\(/gi, '_cwavg(');
        expr = expr.replace(/\bwavg\s*\(/gi,  '_wavg(');
        expr = expr.replace(/:/g, ',');

        // 5. Renomeia demais funções para versões locais
        expr = expr.replace(/\bccount\b/gi, '_ccount');
        expr = expr.replace(/\bcavg\b/gi,   '_cavg');
        expr = expr.replace(/\bcsum\b/gi,   '_csum');
        expr = expr.replace(/\bcsub\b/gi,   '_csub');
        expr = expr.replace(/\bcmul\b/gi,   '_cmul');
        expr = expr.replace(/\bcdiv\b/gi,   '_cdiv');
        expr = expr.replace(/\bavg\b/gi,    '_avg');
        expr = expr.replace(/\bsum\b/gi,    '_sum');
        expr = expr.replace(/\bsub\b/gi,    '_sub');
        expr = expr.replace(/\bmin\b/gi,    'Math.min');
        expr = expr.replace(/\bmax\b/gi,    'Math.max');

        // 6. Funções auxiliares (espelham o comportamento do MathEngine C#)
        const _avg  = (...a) => a.length ? a.reduce((s, v) => s + v, 0) / a.length : 0;
        const _sum  = (...a) => a.reduce((s, v) => s + v, 0);
        const _sub  = (...a) => a.reduce((acc, v, i) => i === 0 ? v : acc - v, 0);
        const _wavg = (...a) => {
            let ws = 0, tot = 0;
            for (let i = 0; i + 1 < a.length; i += 2) { ws += a[i] * a[i + 1]; tot += a[i + 1]; }
            return tot ? ws / tot : 0;
        };
        // _parseCond: extrai [operador, limiar] da string de condição do MathEngine
        // Ex: ' !== 0 ' → ['!==', 0]  |  ' > -9999 ' → ['>', -9999]
        const _parseCond = (cond) => {
            const s = String(cond).trim();
            const m = s.match(/^(!==|===|<>|<=|>=|<|>|=)\s*(-?\d+(?:\.\d+)?)$/);
            return m ? [m[1], parseFloat(m[2])] : ['===', NaN];
        };
        const _cond = (sig, thr, v) => {
            if (sig === '<>'  || sig === '!==') return v !== thr;
            if (sig === '='   || sig === '===') return v === thr;
            if (sig === '<')   return v < thr;
            if (sig === '>')   return v > thr;
            if (sig === '<=')  return v <= thr;
            if (sig === '>=')  return v >= thr;
            return false;
        };
        // As funções condicionais recebem a condição como string única: ' !== 0 ', ' > -9999 ', etc.
        const _csum   = (condStr, ...a) => { const [sig, thr] = _parseCond(condStr); return _sum(...a.filter(v => _cond(sig, thr, v))); };
        const _csub   = (condStr, ...a) => { const [sig, thr] = _parseCond(condStr); return _sub(...a.filter(v => _cond(sig, thr, v))); };
        const _cavg   = (condStr, ...a) => { const [sig, thr] = _parseCond(condStr); return _avg(...a.filter(v => _cond(sig, thr, v))); };
        const _cmul   = (condStr, ...a) => { const [sig, thr] = _parseCond(condStr); return a.filter(v => _cond(sig, thr, v)).reduce((acc, v) => acc * v, 1); };
        const _cdiv   = (condStr, ...a) => {
            const [sig, thr] = _parseCond(condStr);
            const f = a.filter(v => _cond(sig, thr, v));
            return f.reduce((acc, v, i) => i === 0 ? v : (v !== 0 ? acc / v : acc), 0);
        };
        const _ccount = (condStr, ...a) => { const [sig, thr] = _parseCond(condStr); return a.filter(v => _cond(sig, thr, v)).length; };
        const _cwavg  = (condStr, ...a) => {
            const [sig, thr] = _parseCond(condStr);
            let ws = 0, tot = 0;
            for (let i = 0; i + 1 < a.length; i += 2) {
                if (_cond(sig, thr, a[i])) { ws += a[i] * a[i + 1]; tot += a[i + 1]; }
            }
            return tot ? ws / tot : 0;
        };

        try {
            // eslint-disable-next-line no-new-func
            const fn = new Function(
                '_avg', '_sum', '_sub', '_wavg', '_cwavg',
                '_csum', '_csub', '_cavg', '_cmul', '_cdiv', '_ccount',
                `"use strict"; return (${expr});`
            );
            const result = fn(_avg, _sum, _sub, _wavg, _cwavg, _csum, _csub, _cavg, _cmul, _cdiv, _ccount);
            if (typeof result !== 'number' || isNaN(result) || !isFinite(result)) return '-';
            return parseFloat(result.toFixed(4));
        } catch (e) {
            return '-';
        }
    },

    async getProductionPlanData(date) {
        if (this._harvestFetchPromise) return this._harvestFetchPromise;
        const params = date ? `?date=${encodeURIComponent(date)}` : '';
        this._harvestFetchPromise = axios.get(`${urlMainAPI}/getInfosHarvestPlan${params}`)
            .then(res => { this.harvestPlanList = res.data; })
            .catch(err => console.error(err))
            .finally(() => { this._harvestFetchPromise = null; });
        return this._harvestFetchPromise;
    },

    clearMemory() {
        this.indicatorsList = []
        this.screenPositionsList = []
    },

    validateFields(object, fields, compare) {
        for (let field of fields) {
            for (let compareItem of compare) {
                if (!object[field] || object[field] == compareItem || (typeof object[field] == "string" && object[field].trim() == compareItem)) return false;
            }
        }

        return true;
    },

    customToast(toast, variant, title, msg) {
        toast.toast(msg, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-bottom-left',
            solid: true
        })
    },

    validateEquation(equation) {
        if (equation.length > 0) {
            let openP = equation.filter(item => item == '(');
            let closeP = equation.filter(item => item == ')');

            if (openP || closeP) {
                if (openP.length != closeP.length) return { status: false, msg: 'Parênteses Inconsistentes' };
            }

            let opsAllowed = ['(', ')', '+', '-', '*', '/', '^', '=', '<', '>', '<=', '>=', '<>', 'AND', 'OR', '0', '-9999', 'true', 'false', 'if', 'else', 'then', ',', ':', "'", 'avg', 'wavg', 'cavg', 'cwavg', 'sum', 'csum', 'sub', 'csub', 'cmul', 'cdiv', 'ccount', 'min', 'max'];
            let checkCombinations =
            [
                '( +', '( -', '( *', '( /', '( ^', '( AND', '( OR', '( ,', '( :', "' )", ", )", ": )", "+ )", "- )", "* )", "/ )", "^ )", ", )", ": )","<> )","> )","< )","<= )",">= )", "= )", "= =",
                ') 0', ') -9999', ') true', ') false', ') ,', ') :', ") '", ') avg', ') wavg', ') cavg', ') cwavg', ') sum', ') csum', ') sub', ') csub', ') cmul', ') cdiv', ') ccount', ') min', ') max',
                '+ )', '+ +', '+ -', '+ *', '+ /', '+ ^', '+ =', '+ <', '+ >', '+ <=', '+ >=', '+ <>', '+ AND', '+ OR', '+ 0', '+ -9999', '+ true', '+ false', '+ if', '+ else', '+ then', '+ ,', '+ :', "+ '", '+ avg', '+ wavg', '+ cavg', '+ cwavg', '+ sum', '+ csum', '+ sub', '+ csub', '+ cmul', '+ cdiv', '+ ccount', '+ min', '+ max',
                '- )', '- +', '- -', '- *', '- /', '- ^', '- =', '- <', '- >', '- <=', '- >=', '- <>', '- AND', '- OR', '- 0', '- -9999', '- true', '- false', '- if', '- else', '- then', '- ,', '- :', "- '", '- avg', '- wavg', '- cavg', '- cwavg', '- sum', '- csum', '- sub', '- csub', '- cmul', '- cdiv', '- ccount', '- min', '- max',
                '* )', '* +', '* -', '* *', '* /', '* ^', '* =', '* <', '* >', '* <=', '* >=', '* <>', '* AND', '* OR', '* 0', '* -9999', '* true', '* false', '* if', '* else', '* then', '* ,', '* :', "* '", '* avg', '* wavg', '* cavg', '* cwavg', '* sum', '* csum', '* sub', '* csub', '* cmul', '* cdiv', '* ccount', '* min', '* max',
                '/ )', '/ +', '/ -', '/ *', '/ /', '/ ^', '/ =', '/ <', '/ >', '/ <=', '/ >=', '/ <>', '/ AND', '/ OR', '/ 0', '/ -9999', '/ true', '/ false', '/ if', '/ else', '/ then', '/ ,', '/ :', "/ '", '/ avg', '/ wavg', '/ cavg', '/ cwavg', '/ sum', '/ csum', '/ sub', '/ csub', '/ cmul', '/ cdiv', '/ ccount', '/ min', '/ max',
                '^ )', '^ +', '^ -', '^ *', '^ /', '^ ^', '^ =', '^ <', '^ >', '^ <=', '^ >=', '^ <>', '^ AND', '^ OR', '^ 0', '^ -9999', '^ true', '^ false', '^ if', '^ else', '^ then', '^ ,', '^ :', "^ '", '^ avg', '^ wavg', '^ cavg', '^ cwavg', '^ sum', '^ csum', '^ sub', '^ csub', '^ cmul', '^ cdiv', '^ ccount', '^ min', '^ max',
                '= )', '= +', '= -', '= *', '= /', '= ^', '= =', '= <', '= >', '= <=', '= >=', '= <>', '= AND', '= OR', '= if', '= else', '= then', '= ,', '= :', "= '", '= avg', '= wavg', '= cavg', '= cwavg', '= sum', '= csum', '= sub', '= csub', '= cmul', '= cdiv', '= ccount', '= min', '= max',
                '< )', '< +', '< -', '< *', '< /', '< ^', '< =', '< <', '< >', '< <=', '< >=', '< <>', '< AND', '< OR', '< true', '< false', '< if', '< else', '< then', '< ,', '< :', "< '", '< avg', '< wavg', '< cavg', '< cwavg', '< sum', '< csum', '< sub', '< csub', '< cmul', '< cdiv', '< ccount', '< min', '< max',
                '> )', '> +', '> -', '> *', '> /', '> ^', '> =', '> <', '> >', '> <=', '> >=', '> <>', '> AND', '> OR', '> true', '> false', '> if', '> else', '> then', '> ,', '> :', "> '", '> avg', '> wavg', '> cavg', '> cwavg', '> sum', '> csum', '> sub', '> csub', '> cmul', '> cdiv', '> ccount', '> min', '> max',
                '<= )', '<= +', '<= -', '<= *', '<= /', '<= ^', '<= =', '<= <', '<= >', '<= <=', '<= >=', '<= <>', '<= AND', '<= OR', '<= true', '<= false', '<= if', '<= else', '<= then', '<= ,', '<= :', "<= '", '<= avg', '<= wavg', '<= cavg', '<= cwavg', '<= sum', '<= csum', '<= sub', '<= csub', '<= cmul', '<= cdiv', '<= ccount', '<= min', '<= max',
                '>= )', '>= +', '>= -', '>= *', '>= /', '>= ^', '>= =', '>= <', '>= >', '>= <=', '>= >=', '>= <>', '>= AND', '>= OR', ', :', ': ,'
            ]
            for (let idx in equation) {
                let currVal = equation[idx];
                let prevIdx = Number(idx) - 1;
                let prevVal = equation[prevIdx];

                if (currVal != undefined && prevVal != undefined && !opsAllowed.includes(currVal) && !opsAllowed.includes(prevVal)) return { status: false, msg: 'Referências Repetidas Inválidas' };

                // if (currVal != '(' && prevVal != '(' && currVal != ')' && prevVal != ')' && currVal != '-9999' && prevVal != '-9999' && currVal != '0' && prevVal != '0' && currVal == prevVal) return { status: false, msg: 'Operadores Repetidos Inválidos' };
                
                if(['avg', 'wavg', 'cavg', 'cwavg', 'sum', 'csum', 'sub', 'csub', 'cmul', 'cdiv', 'ccount', 'min', 'max','if', 'else', 'then'].includes(currVal) && ['avg', 'wavg', 'cavg', 'cwavg', 'sum', 'csum', 'sub', 'csub', 'cmul', 'cdiv', 'ccount', 'min', 'max','if', 'else', 'then'].includes(prevVal)){
                    return { status: false, msg: 'Funções Repetidas Inválidas' };
                }
                
                if(['avg', 'wavg', 'cavg', 'cwavg', 'sum', 'csum', 'sub', 'csub', 'cmul', 'cdiv', 'ccount', 'min', 'max','if', 'else', 'then'].includes(currVal) && prevVal != undefined && ['+', '-', '*', '/', '^', '=', '<', '>', '<=', '>=', '<>'].includes(prevVal)){
                    return { status: false, msg: 'Sequencia de Referências e Funções Inválida.' };
                }

                for (let check of checkCombinations) {
                    let checkArr = check.split(' ');
                    if(currVal == checkArr[1] && prevVal == checkArr[0]){
                        return { status: false, msg: 'Operadores Sequênciais Inválidos.' };
                    }
                }
            }

            let lastOp = equation[equation.length - 1];

            if (opsAllowed.includes(lastOp) && lastOp != ')' && lastOp != '-9999' && lastOp != '0' && lastOp != 'true' && lastOp != 'false') return { status: false, msg: 'Fim da Operação Inválido' }

            let opStr = equation.join(' ');

            if (opStr.includes("( )")) {
                return { status: false, msg: 'Parênteses Vazios' };
            }

           

            
        }

        return { status: true, msg: '' };
    },

    formatCollectedToReturn(equationArr, objectToSend, selectedIndicator, createdReferences) {
        let equationStr = '';
        let equationName = '';

        let hasOp = false;

        let collectorsToCreate = [];

        if (equationArr.length == 1) {
            let aloneItem = equationArr[0]
            if (aloneItem.type == 'operation') {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Apenas Operadores Encontrados', 'Adicione referências antes de salvar.');
                return;
            }
            else if (aloneItem.type == 'reference') {
                if (aloneItem.structure.type == 'fixed' || aloneItem.structure.type == 'calc' || aloneItem.structure.type == 'input' || aloneItem.structure.type == 'external' || aloneItem.structure.type == 'outro') {

                    if (aloneItem.structure.type == 'fixed') {
                        equationName = `ind_calc_real_${selectedIndicator.indicatorName.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '')}_online`
                        equationStr = aloneItem.structure.value.toString().trim().replaceAll(" ","");
                    }

                    if (aloneItem.structure.type == 'calc' || aloneItem.structure.type == 'input' || aloneItem.structure.type == 'external' || aloneItem.structure.type == 'outro') {
                        equationName = aloneItem.label;
                        equationStr = '';
                    }

                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        valueEquation: equationName.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: equationStr == '' ? '' : equationName.toString().trim().replaceAll(" ",""),
                        calcExpression: equationStr.toString().trim()
                    }

                    objectToSend.saveOnCollector = [];

                } else if (aloneItem.structure.type == 'collector') {
                    if(selectedIndicator.valueEquation && selectedIndicator.valueEquation != '' && selectedIndicator.valueEquation.includes('ind')){
                        equationName = selectedIndicator.valueEquation;
                    }else{
                        equationName = `ind_real_${selectedIndicator.indicatorName.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '')}_online`
                    }

                    let foundRef = createdReferences.filter(ref => ref.id == aloneItem.structure.id);

                    let sourceObj = foundRef.length > 0 ? foundRef[0] : aloneItem.structure

                    let colName = equationName

                    let colObj = {
                        collectorName: colName.toString().replaceAll(" ","").trim(),
                        minSaturation: sourceObj.minSaturation.toString().trim(),
                        maxSaturation: sourceObj.maxSaturation.toString().trim(),
                        collectorSyntaxe: sourceObj.collectorBase.toString().trim(),
                        select: sourceObj.select ? sourceObj.select.toString().trim() : '',
                        oldTag: sourceObj.oldTag ? sourceObj.oldTag.toString().trim() : '',
                        from: sourceObj.from ? sourceObj.from.toString().trim() : '',
                        where: sourceObj.where ? sourceObj.where.toString().trim() : '',
                        dbid: sourceObj.dbid ? sourceObj.dbid.toString().trim() : "0",
                        dbname: sourceObj.dbname ? sourceObj.dbname.toString().trim() : '',
                        colType: sourceObj.colType ? sourceObj.colType.toString().trim() : ''
                    }

                    if (colObj.colType != '') {
                        if (sourceObj.colType.toLowerCase() == 'opc') {
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.opctagname = sourceObj.opctagname.toString().trim();
                            colObj.opcserver = sourceObj.opcserver.toString().trim();
                            colObj.host = sourceObj.host.toString().trim();
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";

                        } else if (sourceObj.colType.toLowerCase() == 'intelup') {
                            colObj.id = sourceObj.id.toString() ? sourceObj.id.toString().trim() : '';
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.inteluptagname = sourceObj.inteluptagname.toString().trim();
                            colObj.productionunit = sourceObj.productionunit ? sourceObj.productionunit.toString().trim() : '';
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";
                        } else if (sourceObj.colType.toLowerCase() == 'pisystem') {
                            colObj.id = sourceObj.id.toString() ? sourceObj.id.toString().trim() : '';
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.pitagname = sourceObj.pitagname.toString().trim();
                            colObj.filter = sourceObj.filter.toString().trim();
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";
                        } else if (sourceObj.colType.toLowerCase() == 'webservice') {
                            colObj.id = sourceObj.id.toString() ? sourceObj.id.toString().trim() : '';
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.description = sourceObj.description.toString().trim();
                            colObj.webservice = sourceObj.webserviceName.toString().trim();
                            colObj.corporation = sourceObj.corporation.toString().trim();
                            colObj.equipment = sourceObj.equipment.toString().trim();
                            colObj.material = sourceObj.material.toString().trim();
                            colObj.property = sourceObj.property.toString().trim();
                            colObj.indicator = sourceObj.indicator.toString().trim();
                            colObj.acumulate = sourceObj.acumulate.toString().trim();
                            colObj.average = sourceObj.average.toString().trim();
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";
                        }
                        else if (sourceObj.colType.toLowerCase() == 'sap') {
                            colObj.tagname = sourceObj.materialFeature.toString().replaceAll(" ","").trim();
                            colObj.materialFeature = sourceObj.materialFeature.toString().trim();
                            colObj.center = sourceObj.center.toString().trim();
                        }
                        else if (sourceObj.colType.toLowerCase() == 'gatec') {
                            colObj.tagname = sourceObj.cod_variavel.toString().replaceAll(" ","").trim();
                            colObj.cod_variavel = sourceObj.cod_variavel.toString().trim();
                        }
                        else if (sourceObj.colType.toLowerCase() == 'pims') {
                            colObj.tagname = sourceObj.Var_Codigo.toString().replaceAll(" ","").trim();
                            colObj.Var_Codigo = sourceObj.Var_Codigo.toString().replaceAll(" ","").trim();
                            colObj.emp_codemp = sourceObj.emp_codemp.toString().trim();
                            colObj.SUF_CODIGO = sourceObj.SUF_CODIGO ? sourceObj.SUF_CODIGO.toString().trim() : '';
                        }
                    }

                    colObj.isNew = "true";

                    if (selectedIndicator.realRefs && selectedIndicator.realRefs.createdReferences) {
                        let existed = selectedIndicator.realRefs.createdReferences.filter(refs => refs.id == sourceObj.id)

                        if (existed.length > 0) colObj.isNew = "false";
                    }

                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        valueEquation: equationName.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: '',
                        calcExpression: ''
                    }

                    collectorsToCreate.push(colObj);

                    objectToSend.saveOnCollector = [...collectorsToCreate];

                } else if (aloneItem.structure.indicatorName || aloneItem.structure.type == "external") {
                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        valueEquation: aloneItem.structure.valueEquation.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: '',
                        calcExpression: ''
                    }

                    objectToSend.saveOnCollector = [];
                }
            }
        } else {
            for (let item of equationArr) {
                if (item.type == "operation") {
                    hasOp = true;

                    equationStr += `${item.label} `;
                } else if (item.type == 'reference' && item.structure && item.structure.type == 'fixed') {
                    equationStr += `${item.structure.value} `;
                } else if (item.type == 'reference' && item.structure && item.structure.type == "collector") {
                    let foundRef = createdReferences.filter(ref => ref.id == item.structure.id);

                    let sourceObj = foundRef.length > 0 ? foundRef[0] : item.structure
                    
                    let colName = `ind_real_${sourceObj.label.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '').trim()}_online`;

                    if(sourceObj.originalColName && sourceObj.originalColName != undefined) colName = sourceObj.originalColName;

                    let colObj = {
                        collectorName: colName.toString().replaceAll(" ","").trim(),
                        minSaturation: sourceObj.minSaturation.toString().trim(),
                        maxSaturation: sourceObj.maxSaturation.toString().trim(),
                        collectorSyntaxe: sourceObj.collectorBase.toString().trim(),
                        select: sourceObj.select ? sourceObj.select.toString().trim() : '',
                        oldTag: sourceObj.oldTag ? sourceObj.oldTag.toString().trim() : '',
                        from: sourceObj.from ? sourceObj.from.toString().trim() : '',
                        where: sourceObj.where ? sourceObj.where.toString().trim() : '',
                        dbid: sourceObj.dbid ? sourceObj.dbid.toString().trim() : "0",
                        dbname: sourceObj.dbname ? sourceObj.dbname.toString().trim() : '',
                        colType: sourceObj.colType ? sourceObj.colType.toString().trim() : ''
                    }

                    if (colObj.colType != '') {
                        if (sourceObj.colType.toLowerCase() == 'opc') {
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.opctagname = sourceObj.opctagname.toString().trim();
                            colObj.opcserver = sourceObj.opcserver.toString().trim();
                            colObj.host = sourceObj.host.toString().trim();
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";

                        } else if (sourceObj.colType.toLowerCase() == 'intelup') {
                            colObj.id = sourceObj.id.toString().trim();
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.inteluptagname = sourceObj.inteluptagname.toString().trim();
                            colObj.productionunit = sourceObj.productionunit ? sourceObj.productionunit.toString().trim() : '';
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";
                        } else if (sourceObj.colType.toLowerCase() == 'pisystem') {
                            colObj.id = sourceObj.id.toString().trim();
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.pitagname = sourceObj.pitagname.toString().trim();
                            colObj.filter = sourceObj.filter.toString().trim();
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";
                        } else if (sourceObj.colType.toLowerCase() == 'webservice') {
                            colObj.id = sourceObj.id.toString().trim();
                            colObj.tagname = sourceObj.tagname.toString().replaceAll(" ","").trim();
                            colObj.description = sourceObj.description.toString().trim();
                            colObj.webservice = sourceObj.webserviceName.toString().trim();
                            colObj.corporation = sourceObj.corporation.toString().trim();
                            colObj.equipment = sourceObj.equipment.toString().trim();
                            colObj.material = sourceObj.material.toString().trim();
                            colObj.property = sourceObj.property.toString().trim();
                            colObj.indicator = sourceObj.indicator.toString().trim();
                            colObj.acumulate = sourceObj.acumulate.toString().trim();
                            colObj.average = sourceObj.average.toString().trim();
                            colObj.oldColTag = sourceObj.oldColTag ? sourceObj.oldColTag.toString().trim() : "";
                        }

                        else if (sourceObj.colType.toLowerCase() == 'sap') {
                            colObj.tagname = sourceObj.materialFeature.toString().replaceAll(" ","").trim();
                            colObj.materialFeature = sourceObj.materialFeature.toString().trim();
                            colObj.center = sourceObj.center.toString().trim();
                        }
                        else if (sourceObj.colType.toLowerCase() == 'gatec') {
                            colObj.tagname = sourceObj.cod_variavel.toString().replaceAll(" ","").trim();
                            colObj.cod_variavel = sourceObj.cod_variavel.toString().trim();
                        }
                        else if (sourceObj.colType.toLowerCase() == 'pims') {
                            colObj.tagname = sourceObj.Var_Codigo.toString().replaceAll(" ","").trim();
                            colObj.Var_Codigo = sourceObj.Var_Codigo.toString().replaceAll(" ","").trim();
                            colObj.emp_codemp = sourceObj.emp_codemp.toString().trim();
                            colObj.SUF_CODIGO = sourceObj.SUF_CODIGO ? sourceObj.SUF_CODIGO.toString().trim() : '';
                        }
                    }

                    colObj.isNew = "true";

                    if (selectedIndicator.realRefs && selectedIndicator.realRefs != []) {
                        let existed = selectedIndicator.realRefs.createdReferences.filter(refs => refs.id == sourceObj.id)

                        if (existed.length > 0) colObj.isNew = "false";
                    }

                    collectorsToCreate.push(colObj);

                    equationStr += `${colName} `;
                } else if (item.type == 'calc' || item.type == "input" || item.structure.type == "external" || item.type == "outro") {
                    equationStr += `${item.label} `;
                } else if (item.type == 'reference' && item.structure && item.structure.indicatorName) {
                    equationStr += `${item.label} `;
                }
            }

            if (hasOp) {
                if (selectedIndicator.valueEquation != '' && selectedIndicator.valueEquation != null && selectedIndicator.valueEquation.includes('calc')) {
                    equationName = selectedIndicator.valueEquation
                } else {
                    equationName = `ind_calc_real_${selectedIndicator.indicatorName.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '').trim()}_online`
                }

                objectToSend.saveOnTree = {
                    indicatorId: selectedIndicator.indicatorId.toString().trim(),
                    indicatorName: selectedIndicator.indicatorName.toString().trim(),
                    valueEquation: equationName.toString().trim(),
                }

                objectToSend.saveOnCalculate = {
                    calcName: equationName.toString().trim(),
                    calcExpression: equationStr.toString().trim()
                }

            } else {
                if(selectedIndicator.valueEquation && selectedIndicator.valueEquation != '' && selectedIndicator.valueEquation.includes('ind')){
                    equationName = selectedIndicator.valueEquation;
                }else{
                    equationName = `ind_real_${selectedIndicator.indicatorName.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '').trim()}_online`
                }

                objectToSend.saveOnTree = {
                    indicatorId: selectedIndicator.indicatorId.toString().trim(),
                    indicatorName: selectedIndicator.indicatorName.toString().trim(),
                    valueEquation: equationName.toString().trim(),
                }

                objectToSend.saveOnCalculate = {
                    calcName: '',
                    calcExpression: ''
                }
            }

            objectToSend.saveOnCollector = [...collectorsToCreate]
        }
    },

    formatCalculatedToReturn(equationArr, objectToSend, selectedIndicator) {
        let equationStr = '';
        let equationName = '';

        let hasOp = false;
        let hasOnlyCr = true;

        if (equationArr.length == 1) {
            let aloneItem = equationArr[0]
            if (aloneItem.type == 'operation') {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Apenas Operadores Encontrados', 'Adicione referências antes de salvar.');
                return;
            }
            else if (aloneItem.type == 'reference') {
                if (aloneItem.structure.type == 'fixed' || aloneItem.structure.type.toLowerCase() == 'reference') {

                    equationName = "REFERENCE";
                    equationStr = aloneItem.structure.value.toString().trim();

                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        targetEquation: equationName.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: '',
                        calcExpression: equationStr.toString().trim()
                    }

                    objectToSend.saveOnCollector = [];

                } else if (aloneItem.structure.type == 'input' || aloneItem.structure.type == 'gemeo' || aloneItem.structure.type == 'plan' || aloneItem.structure.type == "external" || aloneItem.structure.type == 'outro') {
                    equationName = aloneItem.label;
                    equationStr = '';

                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        targetEquation: equationName.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: '',
                        calcExpression: ''
                    }

                    objectToSend.saveOnCollector = [];

                } else if (aloneItem.structure.type == 'calc') {
                    if(selectedIndicator.targetEquation && selectedIndicator.targetEquation != '' && selectedIndicator.targetEquation.includes('ind')){
                        equationName = selectedIndicator.targetEquation;
                    }else{
                        equationName = `ind_prev_${selectedIndicator.indicatorName.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '')}_online`
                    }

                    equationStr = aloneItem.label.toString().trim();

                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        targetEquation: equationName.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: equationName.toString().trim(),
                        calcExpression: equationStr.toString().trim()
                    }

                    objectToSend.saveOnCollector = [];
                } else if (aloneItem.structure.indicatorName) {
                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        targetEquation: aloneItem.structure.targetEquation.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: '',
                        calcExpression: ''
                    }

                    objectToSend.saveOnCollector = [];
                }
            }
        } else {
            for (let item of equationArr) {
                if (item.type == "operation") {
                    hasOp = true;

                    equationStr += `${item.label} `;
                } else if (item.type == 'reference' && item.structure && item.structure.type == 'fixed') {
                    equationStr += `${item.structure.value} `;
                } else if (item.type == 'calc' || item.type == "input" || item.structure.type.toLowerCase() == 'gemeo' || item.structure.type == "plan" || item.structure.type == "external"|| item.structure.type == "outro") {
                    equationStr += `${item.label} `;

                    if (item.type == 'calc' || item.type == "input" || item.structure.type == "plan" || item.structure.type == "external" || item.structure.type == "outro") hasOnlyCr = false

                } else if (item.type == 'reference' && item.structure && item.structure.indicatorName) {
                    equationStr += `${item.label} `;
                    hasOnlyCr = false
                }

                if (hasOp) {
                    if (hasOnlyCr) {
                        objectToSend.saveOnTree = {
                            indicatorId: selectedIndicator.indicatorId.toString().trim(),
                            indicatorName: selectedIndicator.indicatorName.toString().trim(),
                            targetEquation: equationStr.toString().trim(),
                        }

                        objectToSend.saveOnCalculate = {
                            calcName: '',
                            calcExpression: ''
                        }

                        objectToSend.saveOnCollector = []

                    } else {
                        if(selectedIndicator.targetEquation && selectedIndicator.targetEquation != '' && selectedIndicator.targetEquation.includes('ind')){
                            equationName = selectedIndicator.targetEquation;
                        }else{
                            equationName = `ind_prev_${selectedIndicator.indicatorName.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '')}_online`
                        }

                        objectToSend.saveOnTree = {
                            indicatorId: selectedIndicator.indicatorId.toString().trim(),
                            indicatorName: selectedIndicator.indicatorName.toString().trim(),
                            targetEquation: equationName.toString().trim(),
                        }

                        objectToSend.saveOnCalculate = {
                            calcName: equationName.toString().trim(),
                            calcExpression: equationStr.toString().trim()
                        }

                        objectToSend.saveOnCollector = []
                    }
                } else {
                    if(selectedIndicator.targetEquation && selectedIndicator.targetEquation != '' && selectedIndicator.targetEquation.includes('ind')){
                        equationName = selectedIndicator.targetEquation;
                    }else{
                        equationName = `ind_prev_${selectedIndicator.indicatorName.replaceAll(" ", "").normalize('NFC').replace(/[^a-zA-Z0-9 ]/g, '')}_online`
                    }

                    objectToSend.saveOnTree = {
                        indicatorId: selectedIndicator.indicatorId.toString().trim(),
                        indicatorName: selectedIndicator.indicatorName.toString().trim(),
                        targetEquation: equationName.toString().trim(),
                    }

                    objectToSend.saveOnCalculate = {
                        calcName: '',
                        calcExpression: ''
                    }
                }

                objectToSend.saveOnCollector = []
            }
        }
    }
}

export default MediatorIndicatorEditor;